
export default {
  data() {
    return {
      activeDeliveryMethod: null,
    };
  },
  props: {
    addressInfo: {
      type: [Array, Object],
    },
    country: {
      type: String,
    },
  },
};
